export default "/fonts/vendor/@fortawesome/fontawesome-free/webfa-regular-400.woff2?1008b5226941c24f44681061d347ad5e";